import constants from "./CONSTANTS";

const actions = {
  getBanners: () => ({
    type: constants.GET_MAIN_PAGE_BANNERS,
  }),
  setBanners: (payload) => ({
    type: constants.SET_MAIN_PAGE_BANNERS,
    payload,
  }),

  getNewsAndBlogsForClientLatest: () => ({
    type: constants.GET_MAIN_PAGE_NEWS_AND_BLOGS,
  }),
  setNewsAndBlogsForClientLatest: (payload) => ({
    type: constants.SET_MAIN_PAGE_NEWS_AND_BLOGS,
    payload,
  }),

  getNewsAndBlogsForClientById: (payload) => ({
    type: constants.GET_NEWS_AND_BLOGS_DETAILD_DATA,
    payload,
  }),
  setNewsAndBlogsForClientById: (payload) => ({
    type: constants.SET_NEWS_AND_BLOGS_DETAILD_DATA,
    payload,
  }),

  setBlogGlobalId: (payload) => ({
    type: constants.SET_NEWS_AND_BLOGS_GLOBAL_ID,
    payload,
  }),

  setGlobalPageLoader: (payload) => ({
    type: constants.SET_GLOBAL_PAGE_LOADER,
    payload,
  }),
};

export default actions;
